import { createRequest, handleErrorCatchLog } from '../Helpers/GenericHelpers'
import { loadProfileOptions } from '../Slices/ConfigurationSlice'
import { UiCodeVersionNumber } from '../Constants/Configuration'
import { getTokenFromSessionStorage } from '../Helpers/TokenHelper'

const getProfileOptions = () => (dispatch, getState) => {
  const state = getState()
  const token = getTokenFromSessionStorage()

  if (!state.present.article.serverConfig || !token) {
    return
  }

  return createRequest(
    `/api/users/profileOptions/?profileId=${state.present.configuration.profileValue}&config=${state.present.article.serverConfig}`,
    'GET',
    null,
    token,
    true,
    true,
  )
    .then(response => response.json())
    .then(data => {
      dispatch((innerDispatch, innerGetState) => {
        const responseState = innerGetState()
        const allMarketplace = responseState.present.configuration.allMarketplace
        const serverConfig = responseState.present.article.serverConfig
        const userValue = responseState.present.configuration.userValue
        const configWorkspace = responseState.present.configuration.publicWorkspace
        const appVersion = data.find(option => option.uiCode === UiCodeVersionNumber)?.value

        innerDispatch(
          loadProfileOptions({
            configurationName: responseState.present.configuration.currentConfiguration,
            defaultProfileOptions: data,
            allMarketplace: allMarketplace,
            serverConfig: serverConfig,
            user: userValue,
            configWorkspace: configWorkspace,
          }),
        )

        return appVersion
      })
    })
    .catch(err => {
      handleErrorCatchLog(err, 'Error on get profile options getProfileOptions')
    })
}

const sendIntegrationLogInfo = () => (dispatch, getState) => {
  const state = getState()
  const token = getTokenFromSessionStorage()

  if (!state.present.configuration.integrationInfo && !token) {
    return
  }

  createRequest('/api/users/logIntegration/', 'POST', state.present.configuration.integrationInfo, token).catch(err => {
    handleErrorCatchLog(err, 'Error in send integration log info logIntegration')
  })
}

export { getProfileOptions, sendIntegrationLogInfo }
